import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import Help_hints from "./help_hints";
import "./css/wepcg_bar.css"

class ServiceSoftwareCancellationBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Invoice Dispute (Service Cancellation)</strong></h1>
            <p>
                This claim type is used if upgrade warranty service is not registered and should be cancelled. Contact our financial claims team in case there is any question or problem.
            </p>
            <h1>SW FOD (Software Feature on Demand)</h1>
            <p>
                This claim type is used if SW FOD authorization code is not registered and should be cancelled.
            </p>
            <p>
                In case authorization code was already used for SW activation, unfortunately cancellation is not possible.
            </p>
            <p>
                Contact our SW FOD team (esdemea@lenovo.com) in case of any questions or problems.
            </p>
            <Help_hints />
        </div>
    }
}

export default ServiceSoftwareCancellationBar;